import React from "react"

export const wrapWithLayout = (
  ssr: boolean
): React.FC<{ element: JSX.Element }> => {
  return ({ element }: { element: JSX.Element }) => {
    return <>{element}</>
  }
}
